import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCaretLeft,
  faCaretRight,
} from "@fortawesome/free-solid-svg-icons";

export default function TimeSwitcher({ driverInstance, callbackUpdateValues }) {
  function next() {
    driverInstance.next();
    notifyChanges();
  }

  function prev() {
    driverInstance.previous();
    notifyChanges();
  }

  function today() {
    driverInstance.today();
    notifyChanges();
  }

  function nextMonth() {
    driverInstance.nextMonth();
    notifyChanges();
  }

  function prevMonth() {
    driverInstance.previousMonth();
    notifyChanges();
  }

  function notifyChanges() {
    callbackUpdateValues({
      from: driverInstance.from,
      to: driverInstance.to,
    });
  }

  return (
    <div className="ui-month-tile ui-calendar-tile-color d-flex flex-column justify-content-center align-items-center">
      <div className="ui-time-switcher-label w-100 text-center text-nowrap text-truncate">
        {driverInstance.switcherLabel()}
      </div>
      <div className="ui-time-switcher-controls w-100 d-flex justify-content-between align-items-center">
        <div className="ui-time-switcher-side d-flex justify-content-end">
          <button
            type="button"
            className="ui-time-switcher-button d-flex justify-content-center align-items-center mr-1"
            onClick={prevMonth}
            title="Vorheriger Monat"
            aria-label="Vorheriger Monat"
          >
            <FontAwesomeIcon
              icon={faAngleDoubleLeft}
              size="lg"
              className="ui-hover-scale-116 text-black"
            />
          </button>
          <button
            type="button"
            className="ui-time-switcher-button d-flex justify-content-center align-items-center"
            onClick={prev}
            title="Vorherige Woche"
            aria-label="Vorherige Woche"
          >
            <FontAwesomeIcon
              icon={faCaretLeft}
              size="lg"
              className="ui-hover-scale-116 text-black"
            />
          </button>
        </div>
        <a className="ui-time-switcher-today cursor-pointer" onClick={today}>
          Heute
        </a>
        <div className="ui-time-switcher-side d-flex justify-content-start">
          <button
            type="button"
            className="ui-time-switcher-button d-flex justify-content-center align-items-center mr-1"
            onClick={next}
            title="Nächste Woche"
            aria-label="Nächste Woche"
          >
            <FontAwesomeIcon
              icon={faCaretRight}
              size="lg"
              className="ui-hover-scale-116 text-black"
            />
          </button>
          <button
            type="button"
            className="ui-time-switcher-button d-flex justify-content-center align-items-center"
            onClick={nextMonth}
            title="Nächster Monat"
            aria-label="Nächster Monat"
          >
            <FontAwesomeIcon
              icon={faAngleDoubleRight}
              size="lg"
              className="ui-hover-scale-116 text-black"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
